import React from 'react';
import {useField} from 'formik';
import {clone, concat, includes, without} from 'lodash';
import Checkbox from 'shared/components/checkbox';
import Fieldset from 'shared/components/fieldset';

const RACES: string[] = [
  'American Indian or Alaska Native',
  'Asian',
  'Black or African American',
  'Hispanic or Latino',
  'Native Hawaiian or Other Pacific Islander',
  'White',
  'Other',
];

const RaceOrEthnicity = () => {
  const [field, , helpers] = useField<string[]>('ethnicity');

  const handleEthnicityClicked = (race: string, checked: boolean) => {
    const currentValue = field.value ? clone(field.value) : [];
    const newValue = checked ? concat(currentValue, race) : without(currentValue, race);
    helpers.setValue(newValue);
  };

  return (
    <Fieldset>
      <Fieldset.Legend>What&apos;s your race or ethnicity?</Fieldset.Legend>
      {RACES.map((race) => (
        <Checkbox
          key={race}
          checked={includes(field.value, race)}
          label={race}
          onChange={(e) => {
            handleEthnicityClicked(race, e.target.checked);
          }}
        />
      ))}
    </Fieldset>
  );
};

export default RaceOrEthnicity;
